import {Component, OnInit} from '@angular/core';
import {IconRegisterService} from '@app/services/icon-register/icon-register.service';
import { HttpClient } from '@angular/common/http';
import {take} from 'rxjs';
import {LocalUrls} from '@assets/contract-faxe/local-urls';
import {AppConfigService} from '@app/services/config/app-config.service';
import {DeploymentConfigData} from '@app/services/config/model/deployment-config-data';
import { BasicDataService } from '@app/services/basic-data/basic-data.service';
import { SessionService } from '@app/services/session/session.service';
import { SignalRService } from '@app/services/signal-r/signal-r.service';
import { PasswordService } from '@app/services/password/password.service';
import { SelectedRaceService } from '@app/services/selected-race.service';
import PullToRefresh from 'pulltorefreshjs';
import { ClientEventFacadeService } from '@app/facade-services/client-event/client-event-facade.service';
import { AppUpdateService } from '@app/services/app-update/app-update.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UpdateSnackbarComponent } from '@app/components/shared/update-snackbar/update-snackbar.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DestroyRef, inject } from '@angular/core';
import { PostRetryService } from '@app/services/post-retry/post-retry.service';
import { ScreenWakeLockService } from '@app/services/screen-wake-lock.service';

@Component({
  selector: 'faxe-root',
  template: `
    <faxe-header></faxe-header>
    <router-outlet></router-outlet>
  `,
    standalone: false
})

export class AppComponent implements OnInit {
  title = 'faxe';
  private destroyRef = inject(DestroyRef);

  constructor(
    private iconService: IconRegisterService,
    private readonly signalRService: SignalRService,
    private httpClient: HttpClient,
    private basicDataService: BasicDataService,
    private sessionService: SessionService,
    private passwordService: PasswordService,
    private selectedRaceService: SelectedRaceService,
    private clientEventFacadeService: ClientEventFacadeService,
    private appUpdateService: AppUpdateService,
    private snackBar: MatSnackBar,
    private screenWakeLockService: ScreenWakeLockService,
    private postRetryService: PostRetryService
  ) {
    console.log('faxe autentication not used. Should start here configureAndLoadDiscoveryDocument');
  }

  ngOnInit(): void {
    this.iconService.registerIcons();
    this.selectedRaceService.init();
    this.passwordService.init();
    this.basicDataService.init();
    this.clientEventFacadeService.init();
    this.signalRService.init();
    this.screenWakeLockService.init();
    this.postRetryService.init();

    this.httpClient.get(LocalUrls.deployment)
      .pipe(take(1))
      .subscribe(file => {
        AppConfigService.initDeployment((file as DeploymentConfigData));
      });

    this.readAndStoreQueryVariable();

    const navigator: any = window.navigator;
    const isInWebAppiOS = (navigator.standalone === true);

    if (isInWebAppiOS){
      PullToRefresh.init({
        mainElement: 'body',
        onRefresh() {
          window.location.reload();
        }
      });
    }

    // Initialize app update service
    this.appUpdateService.init();
    
    // Listen for update availability and show snackbar
    this.appUpdateService.getUpdateAvailable$()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        const snackBarRef = this.snackBar.openFromComponent(UpdateSnackbarComponent, {
          duration: undefined, // Stay open until user interacts
          horizontalPosition: 'center',
          verticalPosition: 'bottom'
        });

        snackBarRef.onAction().subscribe(() => {
          this.appUpdateService.activateUpdate();
        });
      });

  }

  readAndStoreQueryVariable() {
    const query = window.location.search.substring(1);
    const vars = query.split('&');
    vars.map(v => v.split('='))
      .map(pair => this.sessionService.set(pair[0], pair[1]));
  }

}
